import { render, staticRenderFns } from "./IndicadoresCardapioDigital.vue?vue&type=template&id=30f33a40&lang=pug"
import script from "./IndicadoresCardapioDigital.vue?vue&type=script&lang=js"
export * from "./IndicadoresCardapioDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports